<template>
  <div style="
  width: 830px;
  margin: 0px auto;
  padding: 10px 29px;
  background: #eef0f2;
  border: 3px solid #c33c3c96;
  border-radius: 11px;" class="oplatakontragent">
    <div class="row">
      <div class="col-md-6">
        <h4 style="font-weight: bold;color:#3d464c;">
          {{ $t($route.name) }}
          <span v-if="$route.params.id != undefined">№{{ $route.params.id }}</span> <br>
          {{ Dates(datas.datetime) }}
        </h4>
        <button type="button" v-if="$route.params.id!=undefined && settedrule.change==true" @click="Change()"
          class="btn btn-primary change">{{$t('Ўзгартириш')}}</button>
      </div>
      <div class="col-md-6 end" style="padding: 14px 23px;">
        <button type="button" class="mybtn btn saved" @click="Savedokument()" :disabled="changedisabled">
          {{ $t("Сақлаш ва беркитиш") }} <sup>crl+enter</sup>
        </button>
        <router-link class="btn btn-danger" :to="{ path: '/user_pay/index' }">
          <button type="button" class="closebutton">
            <b-icon icon="x-lg"></b-icon>
          </button>
        </router-link>
      </div>
    </div>
    <div class="row">
      <!-- sklad -->
      <div class="col-md-3"></div>
      <div class="col-md-6 topheader">
        <span>
          <label>Склад</label>
          <v-select :clearable="false" class="form-control-sm required md-input" :options="skladlist"
            :disabled="skladhave" v-model="datas.sklad_id" :reduce="name => name.id" label="name">
            <template #search="{ attributes, events }">
              <input class="vs__search" v-bind="attributes" v-on="events" aria-activedescendant="null" />
            </template>
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                <em><b>{{ search }}</b></em>
                {{ $t("бўйича маьлумот йўқ") }}
              </template>
              <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
            </template>
          </v-select>
        </span>
      </div>
      <div class="col-md-3"></div>
      <div class="col-md-6">
        <span class="backblock" style="height: 380px;">
        {{$t('Ходим')}}
        <!-- kontragent -->
        <div class="col-md-12 topheader">
          <span>
            <label>{{$t('Ходим')}}</label>
            <v-select :disabled="changedisabled" :clearable="false" class="form-control-sm required md-input"
              :options="userlist" v-model="datas.staff_id" :reduce="name => name.id" label="name"
              @input="Staffchange()">
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" ref="focused" />
              </template>
            </v-select>
          </span>
        </div>
        <!-- Ostatka -->
        <div class="col-md-12 topheader">
          <span>
            <label>{{ $t("Қолдиқ") }}</label><br>
            <div style="text-align:end!important;">
              <span
                style="padding-left: 5px;">{{datas.current_total|numFormat3}}</span></div>
          </span>
        </div>
        <!-- tipoplata -->
        <!-- summa -->
        <div class="col-md-12 topheader">
          <span>
            <label>Сумма</label>
            <vue-numeric :disabled="changedisabled" v-model="datas.summa" separator="space" class="table-input"
              @change="Summachange()" v-bind:precision="2">
            </vue-numeric>
          </span>
        </div>
        </span>
      </div>
      <div class="col-md-6">
        <span class="backblock" style="height: 380px;">
        Касса
        <!-- tipoplata kassa -->
        <div class="col-md-12 topheader">
          <span>
            <label for="">{{ $t("Тўлов тури") }} Касса</label>
            <v-select :disabled="changedisabled" :clearable="false" class="form-control-sm required md-input"
              :options="paytypelist" @input="Summachange()" v-model="datas.pay_type_id" :reduce="name => name.id"
              label="name">
              <template #list-footer>
                <li style="text-align: center;font-weight:bold;">
                  f4 {{ $t("умумий рўйхат") }}
                </li>
              </template>
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button type="button" class="modallist" v-b-modal.modal-paytypelist>
                  <b-icon icon="three-dots"></b-icon>
                </button>
              </template>
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  <em><b>{{ search }}</b></em>
                  {{ $t("бўйича маьлумот йўқ") }}
                </template>
                <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
              </template>
            </v-select>
          </span>
        </div>
        <!-- kassa summa -->
        <div class="col-md-12 topheader">
          <span>
            <label>Касса Сумма</label>
            <vue-numeric @change="ChangeKassasumma()" :disabled="changedisabled" v-model="datas.kassa_summa" separator="space" class="table-input"
              v-bind:precision="2">
            </vue-numeric>
          </span>
        </div>
        </span>
      </div>
      <div class="row" style="margin: 0!important;">
      </div>
      <!-- komment -->
      <div class="col-md-9 topheader">
        <span>
          <label for="">Комментарий</label>
          <!-- <textarea :disabled="changedisabled" v-model="datas.comment" cols="30" rows="10"></textarea> -->
          <input style="width: 100%;" type="text" :disabled="changedisabled" v-model="datas.comment">
        </span>
      </div>
      <div class="col-md-3 topheader">
        <span>
          <label>Курс</label>
          <input type="text"  :disabled="changedisabled" v-model="datas.dollar_rate"></span>
      </div>
    </div>
  </div>
</template>
<script>
  import $ from "jquery";
  import { print } from "../../components/mixins/print.js";
  export default {
    mixins: [print],
    name: "ChiqimForm",
    data() {
      return {
        sklad: "",
        paytype: "",
        skladlist: [],
        paytypelist: [],
        pay_date: 0,
        userlist: [],
        kontragentlist: []
      };
    },
    props: ["datas"],
    created() {
      let self = this;
      self.$root.$refs.user_pay = self;
      self.$root.$on("skladone", function (getdata) {
        self.sklad = getdata;
      });
      self.$root.$on("skladall", function (getdata) {
        self.skladlist = getdata;
      });
      self.$root.$on("paytypeone", function (getdata) {
        self.paytype = getdata;
      });
      self.$root.$on("paytypeall", function (getdata) {
        self.paytypelist = getdata;
      });
    },
    mounted: function () {
      let self = this;
      self.Userlist();
      self.SetRule('/user_pay/index');
      self.Focus();
    },
    methods: {
      Userlist() {
        let self = this;
        axios
          .get("api/v1/staff")
          .then(function (response) {
            self.userlist = response.data;
          });
      },
      Summachange() {
        if (this.datas.pay_type_id == 3) {
            this.datas.kassa_summa = this.datas.summa / this.datas.dollar_rate;
          }else{
            this.datas.kassa_summa=this.datas.summa;
          }
      },
      ChangeKassasumma() {
        if(this.datas.summa==0){
          if (this.datas.pay_type_id == 3) {
            this.datas.summa = this.datas.kassa_summa*this.datas.dollar_rate;
          }else{
            this.datas.summa = this.datas.kassa_summa;
          }
        }
      },
      Staffchange() {
        let self = this;
        self.datas.current_total = 0;
        axios({
          method: "post",
          url: "api/v1/user_pay/total",
          data: {
            user_id: self.datas.staff_id,
            sklad_id: self.datas.sklad_id,
            datetime: self.datas.datetime
          }
        }).then(function (response) {
              self.datas.current_total =response.data.total.toFixed(3);
          });
      },
      Focus() {
        this.$refs.focused.focus();
      },
      Selectpaytype(index) {
        this.$root.$emit("tableselect", index);
      },
      Savedokument() {
        let self = this;
          if (this.$route.path == "/user_pay/create") {
            var methods = "post";
            var action = "api/v1/user_pay";
          } else {
            var methods = "patch";
            var action = "api/v1/user_pay/id/" + self.$route.params.id;
          }
          axios({
            method: methods,
            url: action,
            data: self.datas
          }).then(function (response) {
            self.$store.state.saved = null;
            self.$router.push({ name: "Ходимга тўлов" });
          });
      },
      Print() {
        let self = this;
        // if (self.rule.change == true) {
          if (this.$route.path == "/user_pay/create") {
            var methods = "post";
            var action = "api/v1/user_pay";
          } else {
            var methods = "patch";
            var action = "api/v1/user_pay/id/" + self.$route.params.id;
            localStorage.setItem("print_type", "Копия");
          }
          axios({
            method: methods,
            url: action,
            data: self.datas
          }).then(function (response) {
            let myWindow;
            myWindow = window.open(
              '#/user_pay/print/' + response.data.id,
              "_blank",
              "width=1000, height=1000"
            );
            self.$store.state.saved = null;
            self.$router.push({ name: "Тўлов" });
          });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .oplatakontragent .topheader>span{
    border: 2px solid rgb(165, 165, 227);
  }
  .md-dialog .md-dialog-container {
    max-width: 768px;
  }
</style>